// extracted by mini-css-extract-plugin
module.exports = {"container":"UserMenu_container__3bBOd","avatar":"UserMenu_avatar__1KlYa","name":"UserMenu_name__2dnGt"};